import { Phone, Mail, MapPin } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL, EMAIL } from "@/config";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#0A181D] text-white/80">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="bg-white rounded-md inline-flex p-3 mb-5">
              <img src="/logo.webp" alt="Virtual Bookkeeping" className="h-14 w-auto" />
            </div>
            <p className="max-w-sm text-white/70 leading-relaxed">
              Down-to-earth bookkeeping, payroll and GST support for tradies and
              small businesses across New Zealand. Bookkeeping made simple.
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Services</h4>
            <ul className="space-y-2.5 text-sm">
              <li><a href="#services" className="hover:text-[#10BFCB] transition-colors">Bookkeeping</a></li>
              <li><a href="#services" className="hover:text-[#10BFCB] transition-colors">GST & PAYE Compliance</a></li>
              <li><a href="#services" className="hover:text-[#10BFCB] transition-colors">Payroll</a></li>
              <li><a href="#services" className="hover:text-[#10BFCB] transition-colors">Financial Reporting</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-white mb-4">Get in touch</h4>
            <ul className="space-y-3 text-sm">
              <li>
                <a href={`tel:${PHONE_TEL}`} className="flex items-center gap-2 hover:text-[#10BFCB] transition-colors">
                  <Phone size={16} /> {PHONE_DISPLAY}
                </a>
              </li>
              <li>
                <a href={`mailto:${EMAIL}`} className="flex items-center gap-2 hover:text-[#10BFCB] transition-colors">
                  <Mail size={16} /> {EMAIL}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <MapPin size={16} /> New Zealand · Remote
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3 text-sm text-white/60">
          <p>© {new Date().getFullYear()} Virtual Bookkeeping. All rights reserved.</p>
          <p>Bookkeeping made simple.</p>
        </div>
      </div>
    </footer>
  );
}
